import { render, staticRenderFns } from "./tableColumn.vue?vue&type=template&id=2fab18cf&scoped=true"
import script from "./tableColumn.vue?vue&type=script&lang=js"
export * from "./tableColumn.vue?vue&type=script&lang=js"
import style0 from "./tableColumn.vue?vue&type=style&index=0&id=2fab18cf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fab18cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fab18cf')) {
      api.createRecord('2fab18cf', component.options)
    } else {
      api.reload('2fab18cf', component.options)
    }
    module.hot.accept("./tableColumn.vue?vue&type=template&id=2fab18cf&scoped=true", function () {
      api.rerender('2fab18cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/airTransport/airlinePushRecords/cmp/tableColumn.vue"
export default component.exports